import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { ILogsListState } from './interfaces';
import { deleteRequest, getRequest } from 'api/requests';
import { ILog } from 'interfaces/main';

// Загрузка списка логов
export const fetchLogs = createAsyncThunk(
  'logsList/fetchLogs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest('log', {}, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Удаление лога
export const removeLog = createAsyncThunk(
  'logsList/removeLog',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await deleteRequest(`log/${id}`);

      return response.data.id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const LogsListSelector = (state: RootState): ILogsListState =>
  state.logsList;

export const LogsListLoadingSelector = createSelector(
  LogsListSelector,
  ({ isLoading }) => isLoading,
);

export const LogsListItemsSelector = createSelector(
  LogsListSelector,
  ({ items }) => items,
);

const initialState: ILogsListState = {
  isLoading: false,
  items: [],
};

const logsListSlice = createSlice({
  name: 'logsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogs.pending, (state) => ({ ...state, isLoading: true }))
      .addCase(fetchLogs.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchLogs.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload,
      }))
      .addCase(removeLog.pending, (state) => ({ ...state, isLoading: true }))
      .addCase(removeLog.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(removeLog.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: state.items.filter((item: ILog) => item.id !== payload),
      }));
  },
});

export default logsListSlice.reducer;
